import { Savings as AuthorizedSavings } from 'containers/Savings'

export default AuthorizedSavings
